import { createDraftSafeSelector } from "@reduxjs/toolkit";
import { infrastructureArchitecturePossibleServicesSelector } from "@/store/infrastructure-architecture/selectors/infrastructureArchitecturePossibleServicesSelector";
import { formatServiceName } from "@/store/infrastructure-architecture/utils/helpers/formatServiceName";
import { SolutionArchitectResourceType } from "@/services/cloudchipr.api";

export const infrastructureArchitecturePossibleServicesWithLabelsSelector =
  createDraftSafeSelector(
    [infrastructureArchitecturePossibleServicesSelector],
    (services) => {
      if (!services) {
        return [];
      }

      return services.map((service: SolutionArchitectResourceType) => ({
        value: service,
        title: formatServiceName(service),
      }));
    },
  );
